import { UNDOABLE_TYPE } from './../shared/redux/enums/undoable.type.enum';
import { Observable, ReplaySubject } from 'rxjs';
import { IAppState } from './../shared/redux/app.store';
import { Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { Unsubscribe } from 'redux';

@Injectable()
export class ReduxService {

	private _stateObs: ReplaySubject<IAppState>;
	private _historyObs: ReplaySubject<any>;
	private _store: string;
	private _undoableType: UNDOABLE_TYPE;
	private reduxUnsubscribe: Unsubscribe;

	constructor(protected ngRedux: NgRedux<IAppState>) {
		this._stateObs = new ReplaySubject<IAppState>(1);
		this._historyObs = new ReplaySubject<any>(1);
	}

	public setup( store: string, undoabeType: UNDOABLE_TYPE ): void {
		// console.log('REDUX SERVICE: setup = ', store, undoabeType);

		this._store = store;
		this._undoableType = undoabeType;

		let state: IAppState;
		if ( ! this.reduxUnsubscribe) {
			this.reduxUnsubscribe = this.ngRedux.subscribe( () => {
				state = this.ngRedux.getState();
				this.sendData( state );
			});
		}
	}

	get stateObs(): Observable<any> {
		return this._stateObs;
	}

	get historyObs(): Observable<any> {
		return this._historyObs;
	}

	public dispatch( action: any ): void {
		const newAction: any = Object.assign( action, {undoableType: this._undoableType} );
		this.ngRedux.dispatch( newAction );
	}

	private sendData( state: IAppState ): void {
		if ( !this._store ) {
			console.warn( 'ReduxService: no store set! First run: ReduxService.setup( store: string, undoabeType: UNDOABLE_TYPE )' );
			return;
		}
		// console.log('REDUX SERVICE: this._store = ', this._store);

		// console.log('REDUX SERVICE: state[this._store] = ', state[this._store]);
		if ( state[this._store] ) {
			if ( this._undoableType === undefined || this._undoableType === UNDOABLE_TYPE.NONE ) {
				this._stateObs.next( state[this._store] );
			} else if ( state[this._store].present && state[this._store].present.fromCommand !== '__INIT__' ) {
				this._stateObs.next( state[this._store].present );
				if ( state[this._store].past && state[this._store].future ) {
					this._historyObs.next( {
						past: state[this._store].past,
						present: state[this._store].present,
						future: state[this._store].future
					});
				}
			}
		}
	}
}
